<template>
  <kab-join>
    <template #content>
      <div class="md-layout md-alignment-center-center">
        <h1>Welcome back!</h1>
      </div>
      <div class="md-layout md-alignment-center-center">
        <p>We are happy to see you again. Please enter your address you used to register and confirm to get back in.</p>
      </div>
      <login-form :errors="errors" />
    </template>
  </kab-join>
</template>

<script>
import KabJoin from "@/components/KabJoin"
import LoginForm from "@/components/LoginForm"
import { mapGetters, mapState } from 'vuex'
export default {
  name: "Login",
  components: {
    KabJoin,
    LoginForm
  },
  computed: { 
    ...mapState([
      'errors'
    ]),
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1, p {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: $color-white;
}
h1 {
  margin-top: 40px;
  font-size: 30px;
  margin-bottom: 5px;
}
p {
  margin-bottom: -40px;
}
</style>
